export const serverEnv = {
    backend: document.settings.backend,
}

export const menuEndpoints = {
    get_menu: "/api/public/v1/menu/get",
}

export const cartEndpoints = {
    get_cart: "/api/public/v1/cart/get",
    add_item: "/api/public/v1/cart/item/add",
    update_item: "/api/public/v1/cart/item/update",
    delete_items: "/api/public/v1/cart/items/remove",
    empty_cart: "/api/public/v1/cart/empty",
}

export const stripeSettingsEndpoints = {
    get_stripe: "/api/public/v1/stripe/get",
    get_intent: "/api/public/v1/stripe/intent/get",
}

export const businessEndpoints = {
    get_location: "/api/public/v1/business/location/get",
    get_info: "/api/public/v1/business/info/get",
    get_active: "/api/public/v1/business/order/active",
}

export const pickupEndponts = {
    get_pickup: "/api/public/v1/pickup/get",
}

export const deliveryEndpoints = {
    get_delivery: "/api/public/v1/delivery/get",
}

export const cashEndpoints = {
    get_cash_settings: "/api/public/v1/cash/get",
}

export const checkoutEndpoints = {
    post_order: "/api/public/v1/checkout",
}

export const orderEndpoints = {
    get_order: "/api/public/v1/order/get",
}

export const eatInEndpoints = {
    get: "/api/public/v1/eat_in/settings/get",
}

export const couponsEndpoints = {
    apply: "/api/public/v1/coupon/apply",
}